import { Button } from '@doda/io-react/common';
import { FC, MutableRefObject } from 'react';
import { UpperLimitErrorText } from 'components/UpperLimitErrorText';
import styles from './index.module.scss';

/**
 * Props
 * @param onClickSearchButton 検索ボタン押下時の処理
 * @param observerRef 監視対象ref
 * @param countAnimationRef 求人件数ref
 * @param validationFlags バリデーションエラーに関するオブジェクト
 */
interface Props {
  onClickSearchButton: () => void;
  observerRef: MutableRefObject<HTMLDivElement | null>;
  countAnimationRef: MutableRefObject<HTMLElement | null>;
  validationFlags?: {
    isIncomeRangeError?: boolean;
    isConditionUpperLimitError?: boolean;
  };
}

export const SearchButtonArea: FC<Props> = ({
  onClickSearchButton,
  observerRef,
  countAnimationRef,
  validationFlags = {},
}) => {
  const { isIncomeRangeError = true, isConditionUpperLimitError = true } =
    validationFlags;

  return (
    <div className={styles['search-sidebar__search-area']} ref={observerRef}>
      {!isConditionUpperLimitError && <UpperLimitErrorText />}
      <p className={styles['search-sidebar__total-count']}>
        この条件の求人数
        <span
          className={styles['search-sidebar__total-count__number']}
          ref={countAnimationRef}
        />
        件
      </p>
      <Button
        variant="green"
        size="S"
        widthPercentage={100}
        onClick={onClickSearchButton}
        disabled={!isIncomeRangeError || !isConditionUpperLimitError}
      >
        検索する
      </Button>
    </div>
  );
};
